
<div class="d-flex flex-row">
  <div class="flex-fill pr-3 w-50">
   
    <div class="dx-fieldset" *ngIf="model">
      <div class="dx-fieldset-header">{{ 'Ihr Ansprechpartner' | translate }}</div>
      <div class="dx-field">
        <div class="dx-field-label jobListTD">{{ 'Ansprechpartner' | translate }}</div>
        <div *ngIf="isManager()" class="dx-field-value {{showPlaceHolders ? 'inputWithPlaceHolder' : 'inputWithOutPlaceHolder' }}">
          <label class="placeLabel {{ model.contactName?.length>0 ? 'placeLabelSmall' : '' }}">{{ 'Ansprechpartner' | translate }}</label>
          <dx-text-box [(value)]="model.contactName" [showClearButton]="true" (onValueChanged)="update()"></dx-text-box>
        </div>
        <div *ngIf="!isManager()" class="dx-field-value">
          {{model.contactName}}
        </div>
      </div>

      <div class="dx-field">
        <div class="dx-field-label jobListTD">{{ 'Email' | translate }}</div>
        <div *ngIf="isManager()" class="dx-field-value {{showPlaceHolders ? 'inputWithPlaceHolder' : 'inputWithOutPlaceHolder' }}">
          <label class="placeLabel {{ model.contactEmail?.length>0 ? 'placeLabelSmall' : '' }}">{{ 'Email' | translate }}</label>
          <dx-text-box [(value)]="model.contactEmail" [showClearButton]="true" (onValueChanged)="update()">
            <dx-validator>
         
              <dxi-validation-rule type="email"
                                   message="{{ 'Bitte geben Sie eine gültige Email-Adresse ein' | translate }}"></dxi-validation-rule>
 
            </dx-validator>
          </dx-text-box>
        </div>
        <div *ngIf="!isManager()" class="dx-field-value">
          {{model.contactEmail}}
        </div>
      </div>
      <div class="dx-field">
        <div class="dx-field-label jobListTD">{{ 'Telefon' | translate }}</div>
        <div *ngIf="isManager()" class="dx-field-value {{showPlaceHolders ? 'inputWithPlaceHolder' : 'inputWithOutPlaceHolder' }}">
          <label class="placeLabel {{ model.contactPhone?.length>0 ? 'placeLabelSmall' : '' }}">{{ 'Telefon' | translate }}</label>
          <dx-text-box [(value)]="model.contactPhone" [showClearButton]="true" (onValueChanged)="update()"></dx-text-box>
        </div>
        <div *ngIf="!isManager()" class="dx-field-value">
          {{model.contactPhone}}
        </div>
      </div>
      <div class="dx-field">
        <div class="dx-field-label jobListTD">{{ 'Domain' | translate }}</div>
        <div *ngIf="isManager()" class="dx-field-value {{showPlaceHolders ? 'inputWithPlaceHolder' : 'inputWithOutPlaceHolder' }}">
          <label class="placeLabel {{ model.domain?.length>0 ? 'placeLabelSmall' : '' }}">{{ 'Domain' | translate }}</label>
          <dx-text-box [(value)]="model.domain" [showClearButton]="true" (onValueChanged)="update()"></dx-text-box>
        </div>
        <div *ngIf="!isManager()" class="dx-field-value">
          {{model.domain}}
        </div>
      </div>

      <div class="dx-field">
        <div class="dx-field-label jobListTD">{{ 'Öffentlich sichtbar' | translate }}</div>
        <div class="dx-field-value">
          <div class="d-flex flex-row pt-2">
            <div class="dx-field-label switch-left">{{ "Nein" | translate }}</div>
            <dx-switch (onValueChanged)="update()" [(value)]="model.isPublic" [disabled]="!isManager()" switchedOffText="{{ 'Nein' | translate  }}" switchedOnText="{{ 'Ja' | translate  }}"></dx-switch>
            <div class="dx-field-label switch-right">{{ "Ja" | translate }}</div>
          </div>
        </div>
      </div>
    </div>
 
  </div>
  
  <div class="flex-fill pl-3 w-50">
   
    <div class="dx-fieldset">
      <div class="dx-fieldset-header">{{ 'Ihr Logo' | translate }}</div>
      <div style="height: 100px;">
        <span *ngIf="!model.logoUrl" class="glyphicon glyphicon-picture" style="font-size: 100px;"></span>
        <img *ngIf="model.logoUrl" src="{{model.logoUrl}}" style="height: 100%;" />
      </div>
      <div *ngIf="isManager()">
        <dx-file-uploader uploadUrl="api/Import/ImportCustomerLogo"
                          [uploadHeaders]="uploadHeaders"
                          [multiple]="false"
                          accept="*"
                          (onUploaded)="onUploaded($event)"
                          (onBeforeSend)="onBeforeSendUpload($event)"
                          (onUploadStarted)="onUploadStarted($event)"
                          [(value)]="value"
                          uploadMode="instantly">
        </dx-file-uploader>
        <b>{{ msg }}</b>
      </div>
    </div>
  </div>

</div>






